/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const maxPayByBonusesResponseSchema = z.object({
	by_bonuses: z.number(),
	balance: z.number(),
	non_integers_allowed: z.boolean(),
});
